import styled from "styled-components";

export const InfoSection = styled.div`
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const InfoLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette[600]};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const InfoValue = styled.span`
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette[900]};
  word-break: break-word;
`;

export const ActionsSection = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;
